/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetZReport200ResponseBreakdownTaxRatesValue
 */
export interface GetZReport200ResponseBreakdownTaxRatesValue {
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdownTaxRatesValue
     */
    taxPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdownTaxRatesValue
     */
    taxableBase: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdownTaxRatesValue
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdownTaxRatesValue
     */
    total: number;
}

/**
 * Check if a given object implements the GetZReport200ResponseBreakdownTaxRatesValue interface.
 */
export function instanceOfGetZReport200ResponseBreakdownTaxRatesValue(value: object): value is GetZReport200ResponseBreakdownTaxRatesValue {
    if (!('taxPercentage' in value) || value['taxPercentage'] === undefined) return false;
    if (!('taxableBase' in value) || value['taxableBase'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseBreakdownTaxRatesValueFromJSON(json: any): GetZReport200ResponseBreakdownTaxRatesValue {
    return GetZReport200ResponseBreakdownTaxRatesValueFromJSONTyped(json, false);
}

export function GetZReport200ResponseBreakdownTaxRatesValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200ResponseBreakdownTaxRatesValue {
    if (json == null) {
        return json;
    }
    return {
        
        'taxPercentage': json['taxPercentage'],
        'taxableBase': json['taxableBase'],
        'tax': json['tax'],
        'total': json['total'],
    };
}

export function GetZReport200ResponseBreakdownTaxRatesValueToJSON(json: any): GetZReport200ResponseBreakdownTaxRatesValue {
    return GetZReport200ResponseBreakdownTaxRatesValueToJSONTyped(json, false);
}

export function GetZReport200ResponseBreakdownTaxRatesValueToJSONTyped(value?: GetZReport200ResponseBreakdownTaxRatesValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taxPercentage': value['taxPercentage'],
        'taxableBase': value['taxableBase'],
        'tax': value['tax'],
        'total': value['total'],
    };
}

